import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GridBaseCase } from '../../grid/grid.base.case';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { PlatformLocation} from '@angular/common';
@Component({
  selector: 'app-mz-button',
  templateUrl: './mz-button.component.html',
  styleUrls: ['./mz-button.component.scss']
})
export class MzButtonComponent extends GridBaseCase {
  constructor(
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private platformlocation:PlatformLocation
  ) { super(); }
  getAction(url) {
    const that=this;
    if(that.platformlocation["location"].hash.replace('#','')){
      localStorage.setItem("backurl",that.platformlocation["location"].hash.replace('#',''));
    }
    if (url) {
      if (url.indexOf("http") > 0) {
        if(this.element.elementInfo.title){
          this.com.goWebPage(url,this.element.elementInfo.title);
        }else{

        }
      } else {
        // this.router.navigateByUrl(url);
        this.com.Go(url);
      } 
    } else {
      this.msg.Show("暂未开通", "middle");
    }
  }
  // goWebPage(url) {
  //   this.router.navigate(['/webpage', { url: url, name: this.element.elementInfo.title }])
  // }
}